import React from "react";

import { Disclosure } from "@headlessui/react";
import { FiChevronDown } from "react-icons/fi";

const FilterToggle = ({ children, title, className,span1,iconClass,top,padding }) => {
  return (
    <Disclosure as="div" key="" className={` w-100 position-relative ${top}`} >
      {({ open }) => (
        <>
          <Disclosure.Button
            className={`${
              className ? className : ""
            } d-flex  outline-none align-items-center  py-4 justify-content-between w-100 fltr ${padding}`}
          >
            <span style={{ fontSize: "1rem",color:"#948E8E" }} className={span1}>
              {title}
            </span>
            <FiChevronDown
              style={{ height: "20px", width: "20px",color:"#948E8E" }}
              className={` ${open ? "rotate-180" : ""} ${iconClass}`}
            />
          </Disclosure.Button>
          <Disclosure.Panel as="dd" className={`mt-5`}>
            {children}
         
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default FilterToggle;
